import React, { FunctionComponent } from 'react';
import { TextArea } from '../../atoms/textArea';
import classnames from 'classnames';

type Props = {
  target: string;
  text: string;
  handleChange: (target: string, value: string) => void;
  fromEntry?: boolean;
 };

export const Presentation: FunctionComponent<Props> = ({
  target,
  text,
  handleChange,
  fromEntry,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">在学中の活動を入力して保存してください</p>
      <TextArea
        className={classnames(
          'person__show__modal__inner--textarea',
          { small: fromEntry }
        )}
        placeholder="インターン・部活動・サークル活動など在学中に特に注力していたアピールポイントを記入してください"
        name={target}
        value={text}
        onChanged={handleChange}
        maxLength={2000}
      />
      <p className="person__show__modal__inner--textarea--words">
        <span>
          残り<span className="red">{text ? 2000 - text.length : 2000}</span>文字
        </span>
      </p>
    </div>
  );
};
